import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { UnauthenticatedLayoutComponent } from './unauthenticated-layout.component';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [SharedModule, RouterModule, CommonModule],
  declarations: [UnauthenticatedLayoutComponent],
  exports: []
})
export class UnauthenticatedLayoutModule { }
